const INDIAN_STATES = [
  "State",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman & Nicobar Islands",
  "Chandigarh",
  "Dadra & Nagar Haveli & Daman & Diu",
  "Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry"
];

window.LoginPage = function LoginPage({ setActiveTab }) {
  const [formMode, setFormMode] = React.useState('login'); // 'login', 'signup', 'forgot'
  const [showPassword, setShowPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [loginForm, setLoginForm] = React.useState({
    phone: '',
    password: ''
  });
  const [signUpForm, setSignUpForm] = React.useState({
    fullName: '',
    email: '',
    city: '',
    state: 'State',
    phone: '',
    otp: '',
    agree: false
  });
  const [forgotForm, setForgotForm] = React.useState({
    phone: '',
    otp: '',
    newPassword: ''
  });

  const [otpRequested, setOtpRequested] = React.useState(false);
  const [otpTimer, setOtpTimer] = React.useState(0);

  const [forgotOtpRequested, setForgotOtpRequested] = React.useState(false);
  const [forgotOtpTimer, setForgotOtpTimer] = React.useState(0);

  const [message, setMessage] = React.useState(null);

  React.useEffect(() => {
    let timer;
    if (otpTimer > 0) {
      timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpTimer]);

  React.useEffect(() => {
    let timer;
    if (forgotOtpTimer > 0) {
      timer = setTimeout(() => setForgotOtpTimer(forgotOtpTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [forgotOtpTimer]);

  const handleRequestOtp = () => {
    if (!signUpForm.phone || signUpForm.phone.length !== 10) {
      setMessage({ type: 'error', text: 'Please enter a valid 10-digit mobile number' });
      return;
    }
    setOtpRequested(true);
    setOtpTimer(30);
    setMessage({ type: 'success', text: 'OTP sent successfully to +91 ' + signUpForm.phone });
  };

  const handleRequestForgotOtp = () => {
    if (!forgotForm.phone || forgotForm.phone.length !== 10) {
      setMessage({ type: 'error', text: 'Please enter a valid 10-digit mobile number' });
      return;
    }
    setForgotOtpRequested(true);
    setForgotOtpTimer(30);
    setMessage({ type: 'success', text: 'OTP sent successfully to +91 ' + forgotForm.phone });
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (!loginForm.phone || loginForm.phone.length !== 10) {
      setMessage({ type: 'error', text: 'Please enter a valid 10-digit mobile number' });
      return;
    }
    if (!loginForm.password) {
      setMessage({ type: 'error', text: 'Please enter your password' });
      return;
    }
    setMessage({ type: 'success', text: 'Login successful! Redirecting to homepage...' });
    setTimeout(() => {
      setActiveTab('home');
    }, 1500);
  };

  const handleSignUpSubmit = (e) => {
    e.preventDefault();
    if (!window.validateEmail(signUpForm.email)) {
      setMessage({ type: 'error', text: 'Please enter valid email' });
      return;
    }
    if (signUpForm.state === 'State') {
      setMessage({ type: 'error', text: 'Please select a valid State' });
      return;
    }
    if (!signUpForm.agree) {
      setMessage({ type: 'error', text: 'You must agree to the Privacy Policy and Terms & Conditions' });
      return;
    }
    if (!signUpForm.otp) {
      setMessage({ type: 'error', text: 'Please enter the OTP' });
      return;
    }
    setMessage({ type: 'success', text: 'Account created successfully! Logging you in...' });
    setTimeout(() => {
      setActiveTab('home');
    }, 1500);
  };

  const handleResetPasswordSubmit = (e) => {
    e.preventDefault();
    if (!forgotForm.otp) {
      setMessage({ type: 'error', text: 'Please enter the OTP' });
      return;
    }
    if (!forgotForm.newPassword || forgotForm.newPassword.length < 6) {
      setMessage({ type: 'error', text: 'Password must be at least 6 characters' });
      return;
    }
    setMessage({ type: 'success', text: 'Password reset successful! Logging you in...' });
    setTimeout(() => {
      setActiveTab('home');
    }, 1500);
  };

  return (
    <div className="py-16 bg-[#f8fafc] min-h-[85vh] flex items-center justify-center px-4 relative overflow-hidden">
      {/* Background Decorative Circles */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 -z-10"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-100/40 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 -z-10"></div>

      <div className="max-w-[480px] w-full bg-white rounded-[2rem] border border-slate-100 shadow-2xl p-8 sm:p-10 relative overflow-hidden flex flex-col justify-between min-h-[580px]">
        
        {/* Top Header */}
        <div className="text-center space-y-2 mb-6">
          <h2 className="font-sans text-3xl font-bold text-[#0f172a] tracking-tight">
            {formMode === 'login' && 'Welcome Back'}
            {formMode === 'signup' && 'Create New Account'}
            {formMode === 'forgot' && 'Reset Password'}
          </h2>
          <p className="font-sans text-slate-500 text-sm">
            {formMode === 'login' && 'Login to continue to your account'}
            {formMode === 'signup' && 'Fill in the details to get started'}
            {formMode === 'forgot' && 'Enter your mobile number to reset password'}
          </p>
        </div>

        {/* Global Feedback Messages */}
        {message && (
          <div className={`mb-4 px-4 py-2.5 rounded-lg text-xs font-sans text-center transition-all ${
            message.type === 'success' 
              ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' 
              : 'bg-rose-50 text-rose-700 border border-rose-200'
          }`}>
            {message.text}
          </div>
        )}

        {/* Login Form Mode */}
        {formMode === 'login' && (
          <form onSubmit={handleLoginSubmit} className="space-y-4 flex-grow">
            
            {/* Mobile Number Input */}
            <div className="space-y-1.5">
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                {/* Fixed Label with Phone Emoji */}
                <div className="flex items-center gap-1.5 pr-2 border-r border-slate-200 shrink-0">
                  <span className="text-base select-none">📞</span>
                  <span className="font-sans text-sm font-semibold text-slate-800">+91</span>
                </div>
                <input
                  type="tel"
                  required
                  placeholder="Enter Mobile Number *"
                  value={loginForm.phone}
                  onChange={(e) => setLoginForm({ ...loginForm, phone: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  className="flex-grow pl-3 font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
                />
              </div>
            </div>

            {/* Password Input */}
            <div className="space-y-1.5">
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">lock</span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  required
                  placeholder="Password"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-slate-400 hover:text-slate-600 transition-colors mr-1"
                >
                  <span className="material-symbols-outlined text-lg">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            <div className="flex justify-between items-center text-xs">
              <button
                type="button"
                onClick={() => {
                  setFormMode('forgot');
                  setMessage(null);
                }}
                className="text-blue-600 font-bold hover:underline"
              >
                Forgot Password?
              </button>
            </div>

            <button
              type="submit"
              className="w-full bg-[#0f172a] hover:bg-slate-900 text-white font-sans text-sm py-3.5 rounded-xl font-bold transition-all shadow-lg active:scale-95 cursor-pointer"
            >
              Login
            </button>

            <div className="text-center space-y-4 pt-2">
              <p className="font-sans text-xs text-slate-500">
                Don’t have an account?{' '}
                <button
                  type="button"
                  onClick={() => {
                    setFormMode('signup');
                    setMessage(null);
                  }}
                  className="text-blue-600 font-bold hover:underline"
                >
                  Sign Up
                </button>
              </p>
              <div className="pt-2 border-t border-slate-100">
                <button
                  type="button"
                  onClick={() => {
                    setActiveTab('admin');
                    window.location.hash = 'admin';
                  }}
                  className="font-sans text-xs font-bold text-slate-500 hover:text-blue-600 transition-colors"
                >
                  🔐 Access Admin Portal
                </button>
              </div>
            </div>

          </form>
        )}

        {/* Sign Up Form Mode */}
        {formMode === 'signup' && (
          <form onSubmit={handleSignUpSubmit} className="space-y-3.5 flex-grow">
            
            {/* Full Name */}
            <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
              <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">person</span>
              <input
                type="text"
                required
                placeholder="Full Name"
                value={signUpForm.fullName}
                onChange={(e) => setSignUpForm({ ...signUpForm, fullName: e.target.value })}
                className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
              />
            </div>

            {/* Email ID */}
            <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
              <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">mail</span>
              <input
                type="email"
                required
                placeholder="Email ID"
                value={signUpForm.email}
                onChange={(e) => setSignUpForm({ ...signUpForm, email: e.target.value })}
                className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
              />
            </div>

            {/* City & State Row */}
            <div className="grid grid-cols-2 gap-3">
              {/* City */}
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">corporate_fare</span>
                <input
                  type="text"
                  required
                  placeholder="City"
                  value={signUpForm.city}
                  onChange={(e) => setSignUpForm({ ...signUpForm, city: e.target.value })}
                  className="w-full font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
                />
              </div>

              {/* State Select dropdown containing all states in India */}
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">map</span>
                <select
                  value={signUpForm.state}
                  onChange={(e) => setSignUpForm({ ...signUpForm, state: e.target.value })}
                  className="w-full font-sans text-sm outline-none text-slate-800 bg-white cursor-pointer"
                >
                  {INDIAN_STATES.map((st) => (
                    <option key={st} value={st}>
                      {st}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Mobile Number & OTP Trigger */}
            <div className="flex items-center border border-slate-200 rounded-xl pl-3 pr-1 py-1.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
              <span className="text-base select-none mr-2 shrink-0">📞</span>
              <div className="flex items-center shrink-0 pr-2 border-r border-slate-200">
                <span className="font-sans text-sm font-semibold text-slate-800">+91</span>
              </div>
              <input
                type="tel"
                required
                placeholder="Mobile Number *"
                value={signUpForm.phone}
                onChange={(e) => setSignUpForm({ ...signUpForm, phone: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                className="flex-grow pl-2.5 font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
              />
              <button
                type="button"
                onClick={handleRequestOtp}
                className="bg-transparent text-blue-600 hover:text-blue-700 font-sans font-bold text-xs px-3 py-1.5 border border-blue-600 rounded-lg transition-all text-center whitespace-nowrap"
              >
                Request OTP
              </button>
            </div>

            {/* Enter OTP & Resend Timer */}
            <div className="flex items-center border border-slate-200 rounded-xl pl-3 pr-2 py-2 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
              <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">verified_user</span>
              <input
                type="text"
                required
                disabled={!otpRequested}
                placeholder="Enter OTP"
                value={signUpForm.otp}
                onChange={(e) => setSignUpForm({ ...signUpForm, otp: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400 disabled:bg-transparent disabled:cursor-not-allowed"
              />
              <button
                type="button"
                disabled={!otpRequested || otpTimer > 0}
                onClick={handleRequestOtp}
                className="text-blue-600 font-sans font-bold text-xs hover:underline disabled:text-slate-400 disabled:no-underline whitespace-nowrap"
              >
                {otpTimer > 0 ? `Resend in ${otpTimer}s` : 'Resend OTP'}
              </button>
            </div>

            {/* Consent Checkbox */}
            <div className="flex items-start gap-2 pt-1">
              <input
                type="checkbox"
                id="consent"
                required
                checked={signUpForm.agree}
                onChange={(e) => setSignUpForm({ ...signUpForm, agree: e.target.checked })}
                className="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-600"
              />
              <label htmlFor="consent" className="font-sans text-xs text-slate-500 leading-normal cursor-pointer select-none">
                I agree to the{' '}
                <a href="#privacy" className="text-blue-600 font-semibold hover:underline">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a href="#terms" className="text-blue-600 font-semibold hover:underline">
                  Terms &amp; Conditions
                </a>
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-[#0f172a] hover:bg-slate-900 text-white font-sans text-sm py-3.5 rounded-xl font-bold transition-all shadow-lg active:scale-95 cursor-pointer"
            >
              Sign Up
            </button>

            {/* Toggle Mode Area */}
            <div className="text-center space-y-4 pt-2">
              <p className="font-sans text-xs text-slate-500">
                Already have an account?{' '}
                <button
                  type="button"
                  onClick={() => {
                    setFormMode('login');
                    setMessage(null);
                  }}
                  className="text-blue-600 font-bold hover:underline"
                >
                  Login
                </button>
              </p>
            </div>

          </form>
        )}

        {/* Forgot Password Reset Form Mode */}
        {formMode === 'forgot' && (
          <form onSubmit={handleResetPasswordSubmit} className="space-y-3.5 flex-grow">
            
            {/* Mobile Number Input */}
            <div className="space-y-1.5">
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                {/* Fixed Label with Phone Emoji */}
                <div className="flex items-center gap-1.5 pr-2 border-r border-slate-200 shrink-0">
                  <span className="text-base select-none">📞</span>
                  <span className="font-sans text-sm font-semibold text-slate-800">+91</span>
                </div>
                <input
                  type="tel"
                  required
                  placeholder="Enter Mobile Number *"
                  value={forgotForm.phone}
                  onChange={(e) => setForgotForm({ ...forgotForm, phone: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  className="flex-grow pl-3 font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
                />
              </div>
            </div>        

            {/* Enter OTP Trigger */}
            <div className="flex items-center border border-slate-200 rounded-xl pl-3 pr-1 py-1.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
              <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">verified_user</span>
              <input
                type="text"
                required
                disabled={!forgotOtpRequested}
                placeholder="Enter OTP"
                value={forgotForm.otp}
                onChange={(e) => setForgotForm({ ...forgotForm, otp: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400 disabled:bg-transparent"
              />
              <button
                type="button"
                onClick={handleRequestForgotOtp}
                className="bg-transparent text-blue-600 hover:text-blue-700 font-sans font-bold text-xs px-3 py-1.5 border border-blue-600 rounded-lg transition-all text-center whitespace-nowrap"
              >
                Request OTP
              </button>
            </div>

            {/* Resend Timer display */}
            {forgotOtpRequested && forgotOtpTimer > 0 && (
              <div className="text-right text-[10px] text-slate-500 font-mono pr-2">
                Resend in {forgotOtpTimer}s
              </div>
            )}

            {/* Enter New Password */}
            <div className="space-y-1.5">
              <div className="flex items-center border border-slate-200 rounded-xl px-3 py-2.5 bg-white focus-within:ring-2 focus-within:ring-blue-600 transition-all">
                <span className="material-symbols-outlined text-slate-400 text-lg mr-2 shrink-0">lock</span>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  required
                  placeholder="Enter New Password"
                  value={forgotForm.newPassword}
                  onChange={(e) => setForgotForm({ ...forgotForm, newPassword: e.target.value })}
                  className="flex-grow font-sans text-sm outline-none text-slate-800 placeholder-slate-400"
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className="text-slate-400 hover:text-slate-600 transition-colors mr-1"
                >
                  <span className="material-symbols-outlined text-lg">
                    {showNewPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            {/* Reset Password Action Button */}
            <button
              type="submit"
              className="w-full bg-[#0a66c2] hover:bg-[#0055a5] text-white py-3.5 rounded-xl font-bold font-sans text-sm transition-all shadow-md flex items-center justify-center gap-2 uppercase tracking-wider mt-2"
            >
              <span className="material-symbols-outlined text-lg">lock_reset</span>
              <span>Reset Password</span>
            </button>

            {/* Back to Login link */}
            <div className="text-center pt-2">
              <button
                type="button"
                onClick={() => {
                  setFormMode('login');
                  setMessage(null);
                }}
                className="text-blue-600 font-bold hover:underline font-sans text-xs bg-transparent border-0 cursor-pointer"
              >
                Back to Login
              </button>
            </div>

          </form>
        )}

        {/* Blueprint Line Art Overlay at the bottom */}
        <div className="w-full h-16 pointer-events-none opacity-20 border-t border-dashed border-slate-200 mt-4 flex items-end justify-between select-none">
          {/* Simple blueprint outline layout of a robotic arm & architectural lines */}
          <svg className="w-full h-12 text-[#0a66c2]" viewBox="0 0 200 40" fill="none" stroke="currentColor" strokeWidth="0.5">
            {/* Robotic Arm Base */}
            <rect x="10" y="30" width="16" height="8" rx="1" />
            <circle cx="18" cy="26" r="3" />
            <line x1="18" y1="26" x2="30" y2="12" />
            <circle cx="30" cy="12" r="2" />
            <line x1="30" y1="12" x2="45" y2="18" />
            <path d="M 45 18 L 48 15 M 45 18 L 47 21" />
            {/* Architectural Building outlines */}
            <line x1="90" y1="40" x2="90" y2="10" />
            <line x1="90" y1="10" x2="110" y2="15" />
            <line x1="110" y1="15" x2="110" y2="40" />
            <line x1="90" y1="20" x2="110" y2="25" />
            <line x1="90" y1="30" x2="110" y2="35" />
            
            <line x1="120" y1="40" x2="120" y2="5" />
            <line x1="120" y1="5" x2="145" y2="5" />
            <line x1="145" y1="5" x2="145" y2="40" />
            <line x1="120" y1="15" x2="145" y2="15" />
            <line x1="120" y1="28" x2="145" y2="28" />

            <line x1="155" y1="40" x2="155" y2="20" />
            <line x1="155" y1="20" x2="175" y2="20" />
            <line x1="175" y1="20" x2="175" y2="40" />
            <line x1="155" y1="30" x2="175" y2="30" />
          </svg>
        </div>

      </div>
    </div>
  );
};
